(function () {
  function init() {
    var grid = document.getElementById('dh-gallery-grid');
    var lb   = document.getElementById('dh-lightbox');
    if (!grid || !lb) return;

    var lbImg     = lb.querySelector('.dh-lightbox__img');
    var lbCaption = lb.querySelector('.dh-lightbox__caption');
    var lbClose   = lb.querySelector('.dh-lightbox__close');
    var lbPrev    = lb.querySelector('.dh-lightbox__arrow--prev');
    var lbNext    = lb.querySelector('.dh-lightbox__arrow--next');
    var lbOverlay = lb.querySelector('.dh-lightbox__overlay');
    var current   = 0;

    function allItems() {
      return Array.from(document.querySelectorAll('.dh-gallery-grid__item'));
    }

    function visibleItems() {
      return allItems().filter(function (el) {
        return el.style.display !== 'none' && el.getAttribute('data-full-src');
      });
    }

    function updateArrows(total) {
      lbPrev.style.visibility = current === 0        ? 'hidden' : 'visible';
      lbNext.style.visibility = current >= total - 1 ? 'hidden' : 'visible';
    }

    function show(index) {
      var list = visibleItems();
      if (!list.length) return;
      current = Math.max(0, Math.min(list.length - 1, index));
      var el = list[current];
      lbImg.src             = el.getAttribute('data-full-src');
      lbImg.alt             = el.getAttribute('data-caption') || '';
      lbCaption.textContent = el.getAttribute('data-caption') || '';
      updateArrows(list.length);
      lb.classList.add('dh-lightbox--active');
      document.body.style.overflow = 'hidden';
    }

    function closeLb() {
      lb.classList.remove('dh-lightbox--active');
      document.body.style.overflow = '';
      lbImg.src = '';
    }

    // ── Category filter ────────────────────────────────────────────────────────
    function applyFilter(filter) {
      document.querySelectorAll('.dh-gallery-filter-btn').forEach(function (b) {
        b.classList.remove('active');
        if (b.getAttribute('data-filter') === filter) b.classList.add('active');
      });
      allItems().forEach(function (item) {
        item.style.display =
          (filter === 'all' || item.getAttribute('data-category') === filter)
            ? '' : 'none';
      });
    }

    document.querySelectorAll('.dh-gallery-filter-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyFilter(btn.getAttribute('data-filter'));
      });
    });

    // ── URL ?category= auto-filter ─────────────────────────────────────────────
    var param = new URLSearchParams(window.location.search).get('category');
    if (param) applyFilter(param);

    // ── Lightbox grid clicks ───────────────────────────────────────────────────
    grid.addEventListener('click', function (e) {
      var item = e.target.closest('.dh-gallery-grid__item');
      if (!item) return;
      var src = item.getAttribute('data-full-src');
      if (!src) return;
      var list = visibleItems();
      var idx  = list.indexOf(item);
      if (idx !== -1) show(idx);
    });

    // ── Lightbox controls ──────────────────────────────────────────────────────
    lbClose.addEventListener('click', closeLb);
    lbOverlay.addEventListener('click', closeLb);
    lbPrev.addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
    lbNext.addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('dh-lightbox--active')) return;
      if (e.key === 'Escape')     closeLb();
      if (e.key === 'ArrowLeft')  show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
